import { Component, OnInit,Inject, LOCALE_ID  } from '@angular/core';
import { ColorsService } from '../../../shared/colors/colors.service';
import { DatePipe } from '@angular/common';
import { Http } from '@angular/http';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';



@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    
 // Bar chart
    // -----------------------------------
  newData=[];
   barData = {
       labels: [],
       datasets:[{
           data:[]
       }]
    
   };

    barColors = [
        {
            backgroundColor: this.colors.byName('info'),
            borderColor: this.colors.byName('info'),
            pointHoverBackgroundColor: this.colors.byName('info'),
            pointHoverBorderColor: this.colors.byName('info')
        }];

    barOptions = {
        scaleShowVerticalLines: false,
        responsive: true
    };

  // Pie chart
    // -----------------------------------

    pieData = {
        labels: [],
        datasets: [{
            data: []
        }]
    };

    pieColors = [{
        borderColor: [
            this.colors.byName('info'),
            this.colors.byName('yellow'),
            this.colors.byName('purple'),
            this.colors.byName('warning'),
            this.colors.byName('danger'),
            this.colors.byName('inverse'),
            this.colors.byName('pink'),
            this.colors.byName('green'),
            this.colors.byName('gray-darker'),
            this.colors.byName('primary')
        ],
        backgroundColor: [
            this.colors.byName('info'),
            this.colors.byName('yellow'),
            this.colors.byName('purple'),
            this.colors.byName('warning'),
            this.colors.byName('danger'),
            this.colors.byName('inverse'),
            this.colors.byName('gray-darker'),
            this.colors.byName('green'),
            this.colors.byName('pink'),
            this.colors.byName('primary')
        ],
    }];

    pieOptions = {
        responsive: true
    };
     menuItems:any;
     categories:any;
     orders:Array<any>;
     order:any;
     ordersData: FirebaseListObservable<any>;
     datePipeEn: DatePipe = new DatePipe('en-US')
    constructor(private colors: ColorsService, private http: Http, public af :AngularFireDatabase, @Inject(LOCALE_ID) private _locale: string) {
     
     af.list('/menuItems').subscribe((res)=>{
         this.menuItems = res.length;
     });
      af.list('/categories').subscribe((res)=>{
         this.categories = res.length;
     });
      this.ordersData = af.list('/orders');
    
    }

    ngOnInit() {
        this.af.list('/orders', {
              query: {
                orderByChild: 'createdAt',
                limitToLast: 1
              }
            }).subscribe((res)=>{ 
             //   console.log("res in ng" + JSON.stringify(res))
              let lastOrder:any = res;
              var lastDate:any = lastOrder[0].createdAt;
             // console.log()
              var x;
              var dayDuration = 86400000;
                x = 7;
                lastDate -= 6*dayDuration;
         
      
              for(var i = 0; i < x; i++) {
               this.barData.labels.push(this.datePipeEn.transform(lastDate, 'dd MMMM'));
                lastDate += dayDuration;
              }
              this.ordersData.subscribe((res)=>{
              this.orders = res;
              this.order = res.length;
             //console.log(" asd" + this.orders.length + "afd" + this.barData.labels.length);  
              for (var i = 0; i  <= this.barData.labels.length- 1; i++) {
                    var dayValue = 0;
                 for (var j = 0; j  <= this.orders.length- 1; j++) {       
                   var orderDate = this.datePipeEn.transform(this.orders[j].createdAt, 'dd MMMM');
                    if (orderDate === this.barData.labels[i]) {
                      dayValue += this.orders[j].grandTotal;
                    }
                      }
                  this.barData.datasets[0].data.push(dayValue);
               // console.log("data in barData" + JSON.stringify(this.barData));
              }
           })
        })

            //Pie Chart
               this.af.list('/categories').subscribe((category)=>{
                  this.af.list('/menuItems').subscribe((menuitem)=>{
                  for (var i = 0; i  <= category.length- 1; i++) {
                        var x = 0;
                        var quantity = 0;
                         for (var j = 0; j  <= menuitem.length- 1; j++) { 
                         if (menuitem[j].category === category[i].$key) {
                            x++;
                            quantity++;
                         }
                      }
                      this.pieData.labels.push(category[i].title);
                      this.pieData.datasets[0].data.push(quantity);
                     //  console.log("data in pieData" + JSON.stringify(this.pieData));
                    }
                 });
            });
     }
    

    colorByName(name) {
        return this.colors.byName(name);
    }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/home/home/home.component.ts